/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RecipientSelectorSearchRequest} from '@cash-web/protos/squareup/cash/customersearch/api/RecipientSelectorSearch.pb'
import {RecipientSelectorSearchResponse} from '@cash-web/protos/squareup/cash/customersearch/api/RecipientSelectorSearch.pb'


export const recipientSelectorSearch = (request: RecipientSelectorSearchRequest, options?: CashRequestOptions) => post<RecipientSelectorSearchRequest, RecipientSelectorSearchResponse>("/cash-app/recipient-selector/search", request, {...options, rejectOnError: true })